import React, {PureComponent, createRef} from "react";
import "./Header.scss";
import ConfigurationHelper from "../../configuration/ClientConfigurationHelper";

class Header extends PureComponent {
    constructor(props){
        super(props);
        this.mobileSearch = createRef();
    }
    toggleSearchInput = () => {
        this.mobileSearch.current.classList.toggle("show");
    }
    render() {
        return <header className={"tvp-header"}>
            <div className={'container'}>
            <div className={"header-container d-flex align-content-center"}>
                <div className={'header-left d-flex align-self-center'}>
                    <a href={ConfigurationHelper.getGlobalConfiguration().sub_folder+"/"}>
                        <div className={"logo-container"}>
                            <img src={ConfigurationHelper.getDefaultLogo()} alt={ConfigurationHelper.getClientSiteLinks().home}/>
                        </div>
                    </a>
                </div>
                <div className={'header-right ml-auto d-flex align-self-center'}>
                    <div className={"go-to-shop"}>
                        <a href={ConfigurationHelper.getClientSiteLinks().home} target={"_blank"}>
                            <span className={"text"}>SHOP {ConfigurationHelper.getExperienceTitle()}</span>
                            <span className={"icon"}>
                                <svg width="24px" height="24px" viewBox="0 0 24 24">
                                    <path fill="#5a5a5a" d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z" />
                                </svg>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        </header>
    }
}

export default Header;